import { ResponseMapper } from '../../utils/httpclient/response/responsemapper';
import { Logger, LogManager } from '../../utils/logger/logger';
import { SalatiToneDetailsRequest } from '../api/salati/salatitonedetails/salatitonedetailsrequest';
import { SalatiToneDetailsResponse, SalatiToneDetailsResponseDtoImpl } from '../api/salati/salatitonedetails/salatitonedetailsresponse';
import { SalatiToneDetailsBuilder } from '../dto/salatitonedetails/salatitonedetailsbuilder';
import { APIFeatures } from '../util/apifeatures';
import { StatusCodes } from '../util/statuscodes';
import { SixdeeCRBTAPIProcessor } from './sixdeecrbtapiprocessor';

export class SalatiToneDetailsAPIProcessorImpl extends SixdeeCRBTAPIProcessor<SalatiToneDetailsRequest, SalatiToneDetailsResponse>
{
    private LOGGER: Logger = LogManager.getLogger(SalatiToneDetailsAPIProcessorImpl.name);
    execute(request: SalatiToneDetailsRequest): void 
    {
        super.execute(request);
    }

    onSuccess(responseMapper: ResponseMapper): void 
    {
        super.onSuccess(responseMapper);
        this.LOGGER.log("onSuccess() invoked");
        try {

            if (+responseMapper.getStatusCode() === StatusCodes.SUCCESS) {

               let response = new SalatiToneDetailsResponseDtoImpl(APIFeatures.SALATI_TONEDETAILS, "Salati Tone Details Success");

               response.setSalatiToneDetailsDto(new SalatiToneDetailsBuilder(responseMapper.getResponseMap()).buildAll());

               this.getAPISuccess(response);
            }
            else if(+responseMapper.getStatusCode() === StatusCodes.NO_CONTENT)
            {
                this.getAPISuccess(new SalatiToneDetailsResponseDtoImpl(APIFeatures.SALATI_TONEDETAILS, "No Salati Tone Details Data Available"));
            }
            else if(+responseMapper.getStatusCode() === StatusCodes.INTERNAL_SERVER_ERROR)
            {
                this.getAPIFailure(new SalatiToneDetailsResponseDtoImpl(APIFeatures.SALATI_TONEDETAILS, "Internal Server Error"));
            }
        }
        catch (e) {
            this.getAPIFailure(new SalatiToneDetailsResponseDtoImpl(APIFeatures.SALATI_TONEDETAILS, "Internal Server Error"));
        }
    }

    onFailure(responseMapper: ResponseMapper): void 
    {
        super.onFailure(responseMapper);
   
            this.getAPIFailure(new SalatiToneDetailsResponseDtoImpl(APIFeatures.SALATI_TONEDETAILS, responseMapper.getStatusMsg()));
        
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/processor/salatitonedetailsapiprocessor.tsx